import { callBackendApi } from "../axiosInstances/backendInstance/apiRequest";

export async function fetchUserStatistics() {
  const response = callBackendApi("statistics/user-statistics");

  return response;
}
